import { useEffect, useRef, useState } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { GoAlertFill } from "react-icons/go";
import md5 from "md5";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { ErrorMessage, Field, FormikProvider, useFormik, Form } from "formik";
import { MdLockOutline } from "react-icons/md";
import axios from "axios";
import { getTokenExpiry } from "../CommonUtils/TimeUtility";
import { FaEye, FaEyeSlash, FaRegUser } from "react-icons/fa";
import { broadcastNewLogin } from "../CommonUtils/SessionManager";
import { CommonAxiosGet, CommonAxiosPostLogin } from "../CommonUtils/CommonAxios";
import { TfiReload } from "react-icons/tfi";
import { useLocation } from "react-router-dom";
function LoginPage() {
    const [modal, setModal] = useState(false);
    const location = useLocation();

    console.log(location.state);

    const userId = location?.state?.userId;

    console.log("User ID :", userId);
    const validationSchema = Yup.object({
        username: Yup.string().required("User Name is required").nullable(),
        password: Yup.string().required("Password is required").nullable(),
        captcha: Yup.string().required("Captcha is required").nullable(),
    });
    const hasFetchedData = useRef(false);

    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const [error, setError] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const [captcha, setCaptcha] = useState(null);
    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
            captcha: "",
        },
        validationSchema,
        onSubmit: (values, { setSubmitting, setFieldValue }) => {

            const body = {
                userId: values.username,
                userPassword: md5(values.password.trim()),
                captcha: values.captcha,
                captchaId: captchaInput,
                loginType: "aprusa",
            };

            CommonAxiosPostLogin(config.url.FAC_URL + "auth/authenticate", body).then((response) => {
                if (response?.data?.responseCode === "01") {

                    var decodedToken = jwtDecode(response?.data?.accessToken);

                    const tokenExpiry = getTokenExpiry(response.data.accessToken);
                    const refreshExpiry = getTokenExpiry(response.data.refreshToken);

                    Cookies.set("token", response?.data?.accessToken);
                    Cookies.set("refreshToken", response?.data?.refreshToken);
                    Cookies.set("tokenTime", tokenExpiry);
                    Cookies.set("refreshTokenTime", refreshExpiry);
                    sessionStorage.setItem("user_id", decodedToken?.userId);

                    // sessionStorage.setItem("is_changed", decodedToken?.is_changed);

                    console.log("pass", formik?.values?.password)

                    sessionStorage.setItem("is_changed", formik?.values?.password === "@Univ#2026" ? true : decodedToken?.is_changed);
                    sessionStorage.setItem("role_id", decodedToken?.role);
                    sessionStorage.setItem("user_name", decodedToken?.username);
                    broadcastNewLogin();


                    // Load menu
                    CommonAxiosGet(config.url.FAC_URL + "getServices").then((res) => {

                        if (res?.data?.scode === "01") {

                            sessionStorage.setItem("menuData", JSON.stringify(res.data.services));
                            navigate("/RusaDashboard");

                        }
                    });
                }
                else {
                    Swal.fire({
                        text: response?.data?.sdesc,
                        icon: "error",
                        confirmButtonText: "OK",
                        backdrop: false,
                    }).then(() => {

                        if (response?.data?.sdesc === "Invalid Captcha") {
                            setFieldValue("captcha", "");
                            GetCaptcha();
                        }

                        if (
                            response?.data?.sdesc === "Invalid login credentials! Try again." ||
                            response?.data?.sdesc === "Please Check  type of College"
                        ) {
                            setFieldValue("username", "");
                            setFieldValue("password", "");
                            document.getElementById("password").value = null;

                            setFieldValue("captcha", "");
                            GetCaptcha();
                        }
                    });
                }
                setSubmitting(false);
            });
        },
    });
    console.log("ppppppppppppppasss", formik?.values?.password)

    function GetCaptcha() {
        let url = config.url.FAC_URL + `captcha `;
        axios.get(url).then((res) => {
            if (res?.data?.scode === '01') {
                setCaptcha(res?.data?.sdesc)
                setCaptchaInput(res?.data?.captchaId)

            } else {
                setCaptcha('')
                setCaptchaInput('')
            }
        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetCaptcha();
            hasFetchedData.current = true
        }
    }, [])

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    return (
        <>

            <Container fluid className="px-0">
                <div className="parent-wholediv">
                    <Row className="mx-0 login-row-left">
                        <Col xs={16} sm={16} lg={6} md={12} xl={6} xxl={6} className="px-0 parent-loginleftpart">
                            <div className="parlogin-left">

                                <video
                                    className="img-fluid vide-div"
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                >
                                    <source src="../images/2.mp4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                                {/* <div className="login-imgtext">
                                    <p className="mb-0">Andhra Pradesh RUSA (Rashtriya Uchchatar Shiksha Abhiyan) is the state-level implementation of the national RUSA scheme, aimed at strengthening higher education institutions across Andhra Pradesh.
                                        Under Andhra Pradesh Rashtriya Uchchatar Shiksha Abhiyan, the Government of Andhra Pradesh works to improve the quality, access, equity, and governance of state universities and colleges. The programme supports infrastructure development, modernization of classrooms and laboratories, digital learning initiatives, faculty development, research and innovation, accreditation (NAAC/NIRF), and academic reforms.</p>
                                </div> */}
                            </div>

                        </Col>
                        <Col xs={16} sm={16} lg={6} md={12} xl={6} xxl={6} className="parent-loginrightpart">
                            <div className="parlogin-right">
                                <div className="par-logopart">
                                    <img src="../images/ap-logo.webp" alt="" className="img-fluid" />

                                    <div className="paralogo-text">

                                        <h4 className="mb-0">
                                            Commissionerate of Higher Education

                                        </h4>
                                        <p className="mb-0"> Government of Andhra Pradesh</p>
                                    </div>

                                </div>
                                <div className="paralogin-block">
                                    <div className="welcome-head">
                                        <span>
                                            Welcome
                                        </span>
                                        <h5>University Data Collection</h5>
                                    </div>
                                    <div className="login-blockhead">
                                        <h5 className="">Secure Login</h5>
                                    </div>
                                    <div className="paralogin-form">
                                        {error && (
                                            <Alert variant="danger">
                                                <GoAlertFill size={27} /> {error}
                                            </Alert>
                                        )}
                                        <FormikProvider value={formik}>
                                            <Form onSubmit={formik.handleSubmit} onChange={formik.handleChange} className="loginnew-form">
                                                <div className="mb-2">
                                                    <div className="input-group">
                                                        <span>
                                                            <FaRegUser />
                                                        </span>
                                                        <Field
                                                            name="username"
                                                            type="text"
                                                            className="form-control"
                                                            maxLength="16"
                                                            autoComplete="new-password"
                                                            autoCorrect="off"
                                                            placeholder="User Name"
                                                        />
                                                    </div>
                                                    <ErrorMessage name="username" component="div" className="text-danger" />
                                                </div>

                                                <div className="mb-3">
                                                    {/* <label>Password</label> */}
                                                    <label htmlFor="password" className='form-headings'>Password</label>

                                                    <div style={{ position: "relative" }}>
                                                        <div className="input-group">
                                                            <span>
                                                                <MdLockOutline />
                                                            </span>

                                                            <input
                                                                type={showPassword ? 'text' : 'password'}
                                                                name="password"
                                                                className="form-control"
                                                                placeholder="Password"
                                                                autoComplete="new-password"
                                                                style={{ paddingRight: "40px" }}

                                                                maxLength="20"
                                                                id="password"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={togglePasswordVisibility}
                                                                className="toggle-password-btn"
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '10px',
                                                                    top: '26px',
                                                                    border: 'none',
                                                                    background: 'transparent',
                                                                    cursor: 'pointer',
                                                                    color: '#000',
                                                                }}
                                                            >
                                                            </button>

                                                        </div>


                                                        <span
                                                            role="button"
                                                            tabIndex={0}
                                                            onClick={() => {
                                                                setShowPassword(!showPassword);
                                                                togglePasswordVisibility();
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    setShowPassword(!showPassword);
                                                                    togglePasswordVisibility();
                                                                }
                                                            }}
                                                            style={{
                                                                position: "absolute",
                                                                right: "10px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                                userSelect: "none",
                                                            }}
                                                        >
                                                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                                                        </span>

                                                        <ErrorMessage
                                                            name="password"
                                                            component="div"
                                                            className="text-danger"
                                                        />
                                                    </div>


                                                </div>



                                                <div className="mb-3">
                                                    <div className="d-flex gap-2">
                                                        <Field
                                                            name="captcha"
                                                            type="text"
                                                            maxLength="5"
                                                            className="form-control capcha-field"
                                                            placeholder='Enter Captcha'
                                                        />


                                                        <div
                                                            style={{
                                                                background: "#f0f0f0",
                                                                padding: "8px 12px",
                                                                fontWeight: "bold",
                                                                letterSpacing: "3px",
                                                                userSelect: "none",
                                                            }}
                                                        >
                                                            {captcha && (
                                                                <img src={captcha} alt="Captcha" width="100%" height="100%" />
                                                            )}
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="btn reload-captchabtn"
                                                            onClick={GetCaptcha}
                                                        >
                                                            <TfiReload />
                                                        </button>
                                                    </div>
                                                    <ErrorMessage name="captcha" component="div" className="text-danger" />
                                                </div>

                                                <button
                                                    type="submit"
                                                    className="btn login-btn w-100"
                                                >
                                                    Login
                                                </button>


                                                <div className="forgot-div">
                                                    <span
                                                        role="button"
                                                        tabIndex={0}
                                                        onClick={() => navigate("/ForgotPassword")}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " ") {
                                                                e.preventDefault();
                                                                navigate("/ForgotPassword");
                                                            }
                                                        }}
                                                        style={{ cursor: "pointer", color: "#0d6efd" }}
                                                    >
                                                        Forgot Password?
                                                    </span>
                                                </div>

                                            </Form>
                                        </FormikProvider>

                                    </div>
                                </div>
                                <div className="login-footer text-center">
                                    <div className="footer-div">
                                        <p>Designed and Developed by <a href="https://apcfss.in/"><img src="../images/footer-logo.svg" alt="" className="img-fluid" /></a></p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );

}
export default LoginPage;